import { http } from '../../core/services/http';

export const changePassword = (data: any) =>
  http
    .post('/portal/vendor/users/resetPassword', data)
    .catch(({ response: { status, statusText, data } }) => Promise.reject({ status, statusText, ...data }));
